import React, { Component } from 'react';
import { Row, Col, Grid, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid'
import { Data } from 'react-data-grid-addons';
import _ from 'lodash';
import moment from 'moment';

const styles = {
  table: {
    display: 'flex',
    flexDirection: 'row',
    width: '800px',
    alignItems: 'center',
  },
}

class SoListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
    };
  }

  componentDidMount() {
    this.setState({
      rows: this.props.soLines,
    })
  }

  render() {
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }
    const columns = [
      {
        key: 'sonum',
        name: <Translate value="so_no" />,
        resizable: true,
        width: 100,
      },
      {
        key: 'so_qty',
        name: <Translate value="qty" />,
        resizable: true,
        width: 60,
      },
      {
        key: 'unitprices',
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 60,
      },
      {
        key: 'customer_name',
        name: <Translate value="customer" />,
        resizable: true,
        width: 120,
      },
      {
        key: 'cpo',
        name: <Translate value="cpo" />,
        resizable: true,
        width: 80,
      },
      {
        key: 'order_date',
        name: <Translate value="ordered" />,
        width: 95,
        resizable: true,
        formatter: ({ value }) => {
          return <div>
            {value ? moment(value).format('MM-DD-YYYY') : ''}
          </div>
        }
      },
      {
        key: 'etd_date',
        name: <Translate value="edt_date" />,
        width: 95,
        resizable: true,
        formatter: ({ value }) => {
          return <div>
            {value ? moment(value).format('MM-DD-YYYY') : ''}
          </div>
        }
      },
      {
        key: 'creator',
        name: <Translate value="creator" />,
        resizable: true,
        width: 95,
      },
      {
        key: 'sales',
        name: <Translate value="sales" />,
        resizable: true,
        width: 95,
      },
    ];
    return (
      <div id='productInvSOTbale' style={styles.table}>
        <ReactDataGrid
          rowKey="id"
          rowHeight={25}
          columns={columns}
          minHeight={300}
          rowGetter={rowGetter}
          rowsCount={getSize()}
        />
      </div>
    )
  }
}

export default SoListModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/SoListModal.jsx